export enum PersonVariant {
  Officer = 'Officer',
  Owner = 'Owner',
  AuthorizedSigner = 'Authorized Signer',
}
